import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import {
  LoginByEmailParams,
  LoginByEmailResponse,
  loginByEmail,
} from '@utils/backend-api/sessions';

export default function useLoginByEmail() {
  const { mutate, mutateAsync, data, isLoading, isError } = useMutation(
    (params: LoginByEmailParams) => loginByEmail(params),
    {
      onSuccess: (response: LoginByEmailResponse) => {
        if (response.redirectUrl) {
          window.location.href = response.redirectUrl;
        }
      },
      onError: (error: { message: string }) => {
        toast.error(error.message);
      },
    }
  );
  return { mutate, mutateAsync, data, isLoading, isError };
}
